import Api from "../..";
import TransmedFormField, {
  TransmedFormFieldInput,
} from "../../../dtos/transmed/process/form/field";
import transform from "../../../service/transform";

export default class TransmedFormFieldApi extends Api {
  constructor() {
    super("transmed/form/field");
  }

  public async post(data: TransmedFormFieldInput): Promise<TransmedFormField> {
    return await transform(TransmedFormField)((await super.post(data)).data);
  }

  public async put(
    id: string,
    data: TransmedFormFieldInput
  ): Promise<TransmedFormField> {
    return await transform(TransmedFormField)((await super.put(id, data)).data);
  }

  public async delete(id: string): Promise<void> {
    await super.delete(id);
  }
}
